import Table from "./Table";
import { EmissionsSourceSummary } from "../api/models/EmissionsSource";
import {
    dataStatusOptions,
} from "../constants";
import { formatNumber } from "../utils/formatNumber";

export type EmissionSourcesTableProps = {
    onRowClick: (id: number) => void;
    emissionSources: EmissionsSourceSummary[];
    orderBy?: string;
    onOrderBy: (orderBy: string) => void;
    sortOrder?: string;
};

const MaterialEmissionsSourcesTable = ({
    onRowClick,
    emissionSources,
    orderBy,
    sortOrder,
    onOrderBy,
}: EmissionSourcesTableProps) => {
    return (
        <Table
            className="!min-w-[1200px]"
            headings={[
                {
                    label: "Name",
                    orderByKey: "Name",
                },
                { label: "Portfolio"},
                { label: "Sector"},
                { label: "Scope", orderByKey: "Scope" },
                { label: "Data Collection" },
                { label: "Enterprise Value (£)"},
                { label: "Outstanding Amount (£)"},
                { label: "Emissions (kg CO2e)" },
                { label: "Financed Emissions (kg CO2e)" },
            ]}
            data={emissionSources}
            renderRowCells={(rowData) => (
                <>
                    <td className="min-w-[55px]">{rowData.name}</td>
                    <td>{rowData.portfolioName}</td>
                    <td>{rowData.sectorName}</td>
                    <td>{rowData.scope}</td>
                    <td className="min-w-[45px]">
                        <div className="flex items-center space-x-3">
                            {dataStatusOptions.find(dataStatus => rowData.dataStatusId === dataStatus.value)?.label}
                        </div>
                    </td>
                    <td className="min-w-[50px]">
                        {formatNumber(rowData.enterpriseValue)}
                    </td>
                    <td className="min-w-[55px]">
                        {formatNumber(rowData.outstandingAmount)}
                    </td>
                    <td>
                        {rowData.activityDataCo2eKgInPeriod}
                    </td>
                    <td className="min-w-[55px]">{formatNumber(rowData.financedEmissionsInPeriod)}</td>
                    
                </>
            )}
            onRowClick={(rowData) => onRowClick(rowData.id)}
            orderBy={orderBy}
            sortOrder={sortOrder}
            onOrderBy={onOrderBy}
        />
    );
};

export default MaterialEmissionsSourcesTable;
